import React from 'react';
import { useQueryLoadStatus } from '../hooks/useQueryLoadStatus';

/** Inline muted status for toolbars while a query is refetching with existing data. */
export function QueryLoadStatus({
  isLoading = false,
  isFetching = false,
  hasData = false,
  updatingLabel = 'Updating…',
  className = '',
}) {
  const { message, isBackground } = useQueryLoadStatus({
    isLoading,
    isFetching,
    hasData,
    updatingLabel,
  });

  if (!isBackground || !message) return null;

  return (
    <span
      className={`query-load-status${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
    >
      {message}
    </span>
  );
}

/** Full-page / section placeholder with progressive elapsed copy. */
export function QueryLoadingPanel({
  isLoading = true,
  isFetching = false,
  hasData = false,
  initialLabel = 'Loading…',
  className = '',
}) {
  const { message } = useQueryLoadStatus({
    isLoading: isLoading || (!hasData && isFetching),
    isFetching,
    hasData,
    initialLabel,
  });

  return (
    <div
      className={`loading query-loading-panel${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="query-loading-spinner" aria-hidden="true" />
      <p>{message || initialLabel}</p>
    </div>
  );
}

export default QueryLoadStatus;
